// 业绩统计表格-表头
const GuideMenuList = [
  { name: 'employee_number', label: '员工工号' },
  { name: 'salesperson_name', label: '员工姓名' },
  { name: 'store_name', label: '所属门店' },
  { name: 'employee_status_str', label: '员工类型' }
]

const communityMenuList = [
  { name: 'customer_base_name', label: '社群' },
  { name: 'sum_sale_amount', label: '本月销售额' },
  { name: 'sum_order_num', label: '本月订单数' },
  { name: 'no_confirm_commission', label: '本月未确认提成' },
  { name: 'sum_confirm_commission', label: '本月已确认提成' }
]
const UVMenuList = [
  { name: 'employee_number', label: '员工工号' },
  { name: 'salesperson_name', label: '员工姓名' },
  { name: 'store_name', label: '所属门店' },
  { name: 'employee_status', label: '类型' },
  { name: 'count', label: '月客户UV' }
]

const storeMenuList = [
  { name: 'store_name', label: '所属门店' },
  { name: 'store_bn', label: '门店编号' }
]

const employeesStatisticsList = [
  { name: 'salesperson_name', label: '员工' },
  { name: 'employee_status_str', label: '员工类型' },
  { name: 'store_name', label: '当前所属门店' },
  { name: 'store_bn', label: '门店编号' },
  { name: 'count_raw', label: '预计发送客户数' }
]

const customerStatisticsList = [
  { name: 'nickname', label: '客户' },
  { name: 'salesperson_name', label: '发送成员' },
  { name: 'employee_status_str', label: '员工类型' },
  { name: 'store_name', label: '发送成员所属门店' },
  { name: 'store_bn', label: '门店编号' }
  // {name: 'send_time_str', label: '触达时间'},
  // {name: 'count_raw', label: '下单时间'},
  // {name: 'pay', label: '下单实付金额'}
]

export {
  GuideMenuList,
  communityMenuList,
  UVMenuList,
  storeMenuList,
  employeesStatisticsList,
  customerStatisticsList
}
